import { h } from 'preact';
import { OrthomolIcon } from '../../components-common/OrthomolIcon';

interface CtaButtonProps {
  /** Text button (hero, label from the editor's button_1) or icon button (overview card, cart icon) */
  variant?: 'text' | 'icon';
  /** Visible text (text variant) or aria-label (icon variant); from the slot's data-label */
  label: string;
  /** Text variant: Bootstrap button style from the editor (primary, secondary, ...) */
  btnStyle?: string;
  /** Icon variant: the full class list the Twig placeholder button had (positioning lives in the template) */
  className?: string;
  onClick: () => void;
  disabled?: boolean;
  busy?: boolean;
  /** Snapshot says no variant is buyable, or the card has no snapshot: greyed out (Christian's .out-of-stock state) */
  outOfStock?: boolean;
  /**
   * When set, render a plain link instead (shop disabled, Shopware unavailable, no snapshot): never a dead
   * button. Combined with outOfStock the link is greyed out; on the card the click then reaches the PDP via
   * the stretched link, keyboard users follow the href directly.
   */
  fallbackHref?: string | null;
}

export const CtaButton = ({
  variant = 'text',
  label,
  btnStyle = 'primary',
  className,
  onClick,
  disabled,
  busy,
  outOfStock,
  fallbackHref,
}: CtaButtonProps) => {
  const isIcon = variant === 'icon';
  const classes = `${className || `btn btn-block first-button btn-${btnStyle}`}${outOfStock ? ' out-of-stock' : ''}`;
  const content = isIcon ? <OrthomolIcon name="shopping-cart-24" size="20" ariaHidden /> : label;

  if (fallbackHref) {
    return (
      <a href={fallbackHref} className={classes} aria-label={isIcon ? label : undefined}>
        {content}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={classes}
      aria-label={isIcon ? label : undefined}
      disabled={disabled || outOfStock}
      aria-busy={busy}
      aria-disabled={outOfStock || undefined}
      onClick={onClick}
    >
      {content}
    </button>
  );
};
